(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(scope) {
    /* Animate only when supported. Content is never hidden before the observer exists. */
    if (!reduceMotion && 'IntersectionObserver' in window) {
      var reveals = scope.querySelectorAll('.section-head, .cat, .card, .store-information, .page-head');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.08 });
      reveals.forEach(function (el) {
        if (el.dataset.revealReady) return;
        el.dataset.revealReady = 'true';
        el.classList.add('reveal');
        observer.observe(el);
      });
      if (reveals.length) document.documentElement.classList.add('reveal-ready');
    }

    scope.querySelectorAll('[data-quantity-control]').forEach(function (control) {
      if (control.dataset.enhanced) return;
      var input = control.querySelector('input');
      if (!input || input.disabled) return;
      control.dataset.enhanced = 'true';
      var controls = control.querySelectorAll('[data-quantity-change]');
      function sync() {
        var value = Number(input.value);
        var min = Number(input.min || 1);
        var max = input.max ? Number(input.max) : Infinity;
        controls.forEach(function (button) {
          button.hidden = false;
          button.disabled = Number(button.dataset.quantityChange) < 0 ? value <= min : value >= max;
        });
      }
      controls.forEach(function (button) {
        button.addEventListener('click', function () {
          var value = Number(input.value);
          var step = Number(input.step || 1);
          var min = Number(input.min || 1);
          var max = input.max ? Number(input.max) : Infinity;
          input.value = String(Math.min(max, Math.max(min, (Number.isFinite(value) ? value : min) + step * Number(button.dataset.quantityChange))));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          sync();
        });
      });
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      sync();
    });

    /* The sticky submit belongs to the SAME native Shopify form, not another cart pipeline. */
    scope.querySelectorAll('[data-product]').forEach(function (root) {
      var bar = root.querySelector('[data-sticky-buy]');
      var row = root.querySelector('.buy-row');
      var form = root.querySelector('form[id="ProductForm"]');
      if (!bar || !row || !form || bar.dataset.enhanced || !('IntersectionObserver' in window)) return;
      bar.dataset.enhanced = 'true';
      var observer = new IntersectionObserver(function (entries) {
        bar.hidden = entries[0].isIntersecting;
        bar.classList.toggle('is-visible', !bar.hidden);
      }, { threshold: 0 });
      observer.observe(row);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('click', function (event) {
    var nav = document.getElementById('SiteNav');
    var toggle = document.querySelector('[data-menu-toggle]');
    if (!nav || !toggle || !nav.classList.contains('is-open')) return;
    if (event.target.closest('[data-menu-toggle]')) return;
    if (!nav.contains(event.target) || event.target.closest('a')) {
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
  });
})();